import { Button } from 'antd';
import { RiEyeLine, RiFileTextLine, RiInformationLine } from 'react-icons/ri';
import styles from './StudyCardActions.module.css';

interface StudyCardActionsProps {
  hasReport: boolean;
  onOpenStudy: () => void;
  onOpenReport: () => void;
  onStudyInfo: () => void;
}

export default function StudyCardActions({
  hasReport,
  onOpenStudy,
  onOpenReport,
  onStudyInfo,
}: StudyCardActionsProps) {
  return (
    <div className={styles.actions}>
      <Button
        type="default"
        size="small"
        icon={<RiEyeLine />}
        onClick={onOpenStudy}
      >
        Open Study
      </Button>
      <Button
        type="default"
        size="small"
        icon={<RiFileTextLine />}
        onClick={onOpenReport}
        disabled={!hasReport}
      >
        Open Report
      </Button>
      <Button
        type="text"
        size="small"
        icon={<RiInformationLine />}
        onClick={onStudyInfo}
      >
        Study Info
      </Button>
    </div>
  );
}
